import { useState } from 'react';
import type { Props as ReactSelectProps } from 'react-select';

import type { QuotaGroup } from '@api/surveys/utilities/types';
import { RepromptIcon, Button, GlobeIcon, ModalV2 as Modal, Select } from '@utilities';

import QuotaGroupDropdown from './components/QuotaGroupDropdown';
import styles from './_index.module.scss';

interface ModalPreviewProps {
  iframeUrl: string;
  onClose: () => void;
  onQuotaGroupChange: (quotaGroupId: string) => void;
  quotaGroups: QuotaGroup[];
  selectedQuotaGroupId: string;
}

const ModalPreview = ({
  iframeUrl,
  onClose,
  onQuotaGroupChange,
  quotaGroups,
  selectedQuotaGroupId,
}: ModalPreviewProps) => {
  const [question, setQuestion] = useState<ReactSelectProps['value']>(questionOptions[0]);

  const showQuotaGroupDropdown = quotaGroups.length > 1;

  return (
    <Modal
      className={styles['modal-preview']}
      hasCloseIcon
      isActive={true}
      onClose={onClose}
      size="fullscreen"
    >
      <div className={styles['modal-preview-header']}>
        <div className={styles['modal-preview-header-toolbar']}>
          <div className={styles['modal-preview-header-dropdowns']}>
            <QuotaGroupDropdown
              onQuotaGroupChange={onQuotaGroupChange}
              quotaGroups={quotaGroups}
              selectedQuotaGroupId={selectedQuotaGroupId}
            />
            {showQuotaGroupDropdown && (
              <span className={styles['modal-preview-vertical-divider']} />
            )}
            <Select
              className={styles['modal-preview-question-dropdown']}
              onChange={setQuestion}
              options={questionOptions}
              value={question}
            />
          </div>
          <Button
            className={styles['modal-preview-restart-button']}
            icon={<RepromptIcon />}
            text="Restart"
          />
        </div>
        <Button
          className={styles['modal-preview-public-link-button']}
          icon={<GlobeIcon />}
          text="Public Link"
          variant="secondary"
        />
      </div>
      <div className={styles['modal-preview-content']}>
        <div className={styles['modal-preview-viewport']}>
          <div className={styles['modal-preview-mobile-device-frame']}>
            <iframe
              allow="clipboard-write"
              className={styles['modal-preview-iframe']}
              loading="lazy"
              referrerPolicy="strict-origin-when-cross-origin"
              sandbox="allow-popups allow-scripts allow-same-origin"
              src={iframeUrl}
              title="Instant Survey Preview"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

const questionOptions = [
  {
    label: 'What types of products do you typically buy on Amazon?',
    value: 'What types of products do you typically buy on Amazon?',
  },
  {
    label: 'What types of products do you typically buy at Walmart?',
    value: 'What types of products do you typically buy at Walmart?',
  },
];

export default ModalPreview;
